import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Path',
    entityNamePlural: 'Paths',
    entityNameModule: 'path',
  }), [])
}
